export default __webpack_public_path__ + "static/media/intro1.2450fe67.svg";